__turbopack_context__.v({
  "collapsibleItem": "bz7yXW_collapsibleItem",
});
